document.addEventListener('DOMContentLoaded', () => {
  // Make sure all external links open in a new browser tab.
  [...document.querySelectorAll('a')].forEach(a => {
    if (location.hostname !== a.hostname && a.hostname.length !== 0) {
      a.setAttribute('target', '_blank')
      a.setAttribute('rel', 'noopener')
    }
  })
})
